import { AccessControl } from 'accesscontrol'

export const grantList = [
  // ___________________________ADMIN_____________________________________________________
  // work request
  { role: 'admin', resource: 'work_requests', action: 'create:any', attributes: '*' },
  { role: 'admin', resource: 'work_requests', action: 'read:any', attributes: '*' },
  { role: 'admin', resource: 'work_requests', action: 'update:any', attributes: '*' },
  { role: 'admin', resource: 'work_requests', action: 'delete:any', attributes: '*' },

  // paper work requests
  { role: 'admin', resource: 'paper_work_requests', action: 'create:any', attributes: '*' },
  { role: 'admin', resource: 'paper_work_requests', action: 'read:any', attributes: '*' },
  { role: 'admin', resource: 'paper_work_requests', action: 'update:any', attributes: '*' },
  { role: 'admin', resource: 'paper_work_requests', action: 'delete:any', attributes: '*' },

  // questions
  { role: 'admin', resource: 'questions', action: 'create:any', attributes: '*' },
  { role: 'admin', resource: 'questions', action: 'read:any', attributes: '*' },
  { role: 'admin', resource: 'questions', action: 'update:any', attributes: '*' },
  { role: 'admin', resource: 'questions', action: 'delete:any', attributes: '*' },

  { role: 'admin', resource: 'uploaded_questions', action: 'create:any', attributes: '*' },
  { role: 'admin', resource: 'uploaded_questions', action: 'read:any', attributes: '*' },
  { role: 'admin', resource: 'uploaded_questions', action: 'update:any', attributes: '*' },
  { role: 'admin', resource: 'uploaded_questions', action: 'delete:any', attributes: '*' },

  //
  // questions
  { role: 'admin', resource: 'draft_questions', action: 'create:any', attributes: '*' },
  { role: 'admin', resource: 'draft_questions', action: 'read:any', attributes: '*' },
  { role: 'admin', resource: 'draft_questions', action: 'update:any', attributes: '*' },
  { role: 'admin', resource: 'draft_questions', action: 'delete:any', attributes: '*' },

  // mediums
  { role: 'admin', resource: 'mediums', action: 'create:any', attributes: '*' },
  { role: 'admin', resource: 'mediums', action: 'read:any', attributes: '*' },
  { role: 'admin', resource: 'mediums', action: 'update:any', attributes: '*' },
  { role: 'admin', resource: 'mediums', action: 'delete:any', attributes: '*' },
  //grade_levels
  { role: 'admin', resource: 'grade_levels', action: 'create:any', attributes: '*' },
  { role: 'admin', resource: 'grade_levels', action: 'read:any', attributes: '*' },
  { role: 'admin', resource: 'grade_levels', action: 'update:any', attributes: '*' },
  { role: 'admin', resource: 'grade_levels', action: 'delete:any', attributes: '*' },
  //grades
  { role: 'admin', resource: 'grades', action: 'create:any', attributes: '*' },
  { role: 'admin', resource: 'grades', action: 'read:any', attributes: '*' },
  { role: 'admin', resource: 'grades', action: 'update:any', attributes: '*' },
  { role: 'admin', resource: 'grades', action: 'delete:any', attributes: '*' },
  //sections
  { role: 'admin', resource: 'sections', action: 'create:any', attributes: '*' },
  { role: 'admin', resource: 'sections', action: 'read:any', attributes: '*' },
  { role: 'admin', resource: 'sections', action: 'update:any', attributes: '*' },
  { role: 'admin', resource: 'sections', action: 'delete:any', attributes: '*' },
  //competencies
  { role: 'admin', resource: 'competencies', action: 'create:any', attributes: '*' },
  { role: 'admin', resource: 'competencies', action: 'read:any', attributes: '*' },
  { role: 'admin', resource: 'competencies', action: 'update:any', attributes: '*' },
  { role: 'admin', resource: 'competencies', action: 'delete:any', attributes: '*' },
  //competency_aspects
  { role: 'admin', resource: 'competency_aspects', action: 'create:any', attributes: '*' },
  { role: 'admin', resource: 'competency_aspects', action: 'read:any', attributes: '*' },
  { role: 'admin', resource: 'competency_aspects', action: 'update:any', attributes: '*' },
  { role: 'admin', resource: 'competency_aspects', action: 'delete:any', attributes: '*' },

  //competency_aspects
  { role: 'admin', resource: 'competency_types', action: 'create:any', attributes: '*' },
  { role: 'admin', resource: 'competency_types', action: 'read:any', attributes: '*' },
  { role: 'admin', resource: 'competency_types', action: 'update:any', attributes: '*' },
  { role: 'admin', resource: 'competency_types', action: 'delete:any', attributes: '*' },
  //products
  { role: 'admin', resource: 'products', action: 'create:any', attributes: '*' },
  { role: 'admin', resource: 'products', action: 'read:any', attributes: '*' },
  { role: 'admin', resource: 'products', action: 'update:any', attributes: '*' },
  { role: 'admin', resource: 'products', action: 'delete:any', attributes: '*' },

  //papers
  { role: 'admin', resource: 'papers', action: 'create:any', attributes: '*' },
  { role: 'admin', resource: 'papers', action: 'read:any', attributes: '*' },
  { role: 'admin', resource: 'papers', action: 'update:any', attributes: '*' },
  { role: 'admin', resource: 'papers', action: 'delete:any', attributes: '*' },
  //test_tracks
  { role: 'admin', resource: 'test_tracks', action: 'create:any', attributes: '*' },
  { role: 'admin', resource: 'test_tracks', action: 'read:any', attributes: '*' },
  { role: 'admin', resource: 'test_tracks', action: 'update:any', attributes: '*' },
  { role: 'admin', resource: 'test_tracks', action: 'delete:any', attributes: '*' },

  //candidates
  { role: 'admin', resource: 'candidates', action: 'create:any', attributes: '*' },
  { role: 'admin', resource: 'candidates', action: 'read:any', attributes: '*' },
  { role: 'admin', resource: 'candidates', action: 'update:any', attributes: '*' },
  { role: 'admin', resource: 'candidates', action: 'delete:any', attributes: '*' },
  { role: 'admin', resource: 'exam_online_ingest_jobs', action: 'read:any', attributes: '*' },
  { role: 'admin', resource: 'exam_online_ingest_jobs', action: 'update:any', attributes: '*' },
  //themes
  { role: 'admin', resource: 'themes', action: 'create:any', attributes: '*' },
  { role: 'admin', resource: 'themes', action: 'read:any', attributes: '*' },
  { role: 'admin', resource: 'themes', action: 'update:any', attributes: '*' },
  { role: 'admin', resource: 'themes', action: 'delete:any', attributes: '*' },
  //sub_themes
  { role: 'admin', resource: 'sub_themes', action: 'create:any', attributes: '*' },
  { role: 'admin', resource: 'sub_themes', action: 'read:any', attributes: '*' },
  { role: 'admin', resource: 'sub_themes', action: 'update:any', attributes: '*' },
  { role: 'admin', resource: 'sub_themes', action: 'delete:any', attributes: '*' },
  //report_themes
  { role: 'admin', resource: 'report_themes', action: 'create:any', attributes: '*' },
  { role: 'admin', resource: 'report_themes', action: 'read:any', attributes: '*' },
  { role: 'admin', resource: 'report_themes', action: 'update:any', attributes: '*' },
  { role: 'admin', resource: 'report_themes', action: 'delete:any', attributes: '*' },
  //topics
  { role: 'admin', resource: 'topics', action: 'create:any', attributes: '*' },
  { role: 'admin', resource: 'topics', action: 'read:any', attributes: '*' },
  { role: 'admin', resource: 'topics', action: 'update:any', attributes: '*' },
  { role: 'admin', resource: 'topics', action: 'delete:any', attributes: '*' },
  //test_events
  { role: 'admin', resource: 'test_events', action: 'create:any', attributes: '*' },
  { role: 'admin', resource: 'test_events', action: 'read:any', attributes: '*' },
  { role: 'admin', resource: 'test_events', action: 'update:any', attributes: '*' },
  { role: 'admin', resource: 'test_events', action: 'delete:any', attributes: '*' },
  //test_events wr
  { role: 'admin', resource: 'paper_requests', action: 'create:any', attributes: '*' },
  { role: 'admin', resource: 'paper_requests', action: 'read:any', attributes: '*' },
  { role: 'admin', resource: 'paper_requests', action: 'update:any', attributes: '*' },
  { role: 'admin', resource: 'paper_requests', action: 'delete:any', attributes: '*' },
  //blooms_levels
  { role: 'admin', resource: 'blooms_levels', action: 'create:any', attributes: '*' },
  { role: 'admin', resource: 'blooms_levels', action: 'read:any', attributes: '*' },
  { role: 'admin', resource: 'blooms_levels', action: 'update:any', attributes: '*' },
  { role: 'admin', resource: 'blooms_levels', action: 'delete:any', attributes: '*' },
  // difficulty_levels
  { role: 'admin', resource: 'difficulty_levels', action: 'create:any', attributes: '*' },
  { role: 'admin', resource: 'difficulty_levels', action: 'read:any', attributes: '*' },
  { role: 'admin', resource: 'difficulty_levels', action: 'update:any', attributes: '*' },
  { role: 'admin', resource: 'difficulty_levels', action: 'delete:any', attributes: '*' },

  //Bloom's Leve
  { role: 'admin', resource: 'subjects', action: 'create:any', attributes: '*' },
  { role: 'admin', resource: 'subjects', action: 'read:any', attributes: '*' },
  { role: 'admin', resource: 'subjects', action: 'update:any', attributes: '*' },
  { role: 'admin', resource: 'subjects', action: 'delete:any', attributes: '*' },
  //centa_concepts
  { role: 'admin', resource: 'centa_concepts', action: 'create:any', attributes: '*' },
  { role: 'admin', resource: 'centa_concepts', action: 'read:any', attributes: '*' },
  { role: 'admin', resource: 'centa_concepts', action: 'update:any', attributes: '*' },
  { role: 'admin', resource: 'centa_concepts', action: 'delete:any', attributes: '*' },
  //tn_taxonomys
  { role: 'admin', resource: 'tn_taxonomys', action: 'create:any', attributes: '*' },
  { role: 'admin', resource: 'tn_taxonomys', action: 'read:any', attributes: '*' },
  { role: 'admin', resource: 'tn_taxonomys', action: 'update:any', attributes: '*' },
  { role: 'admin', resource: 'tn_taxonomys', action: 'delete:any', attributes: '*' },
  //report
  { role: 'admin', resource: 'report', action: 'create:any', attributes: '*' },
  { role: 'admin', resource: 'report', action: 'read:any', attributes: '*' },
  { role: 'admin', resource: 'report', action: 'update:any', attributes: '*' },
  { role: 'admin', resource: 'report', action: 'delete:any', attributes: '*' },
  //teacher_levels
  { role: 'admin', resource: 'teacher_levels', action: 'create:any', attributes: '*' },
  { role: 'admin', resource: 'teacher_levels', action: 'read:any', attributes: '*' },
  { role: 'admin', resource: 'teacher_levels', action: 'update:any', attributes: '*' },
  { role: 'admin', resource: 'teacher_levels', action: 'delete:any', attributes: '*' },
  //strands
  { role: 'admin', resource: 'strands', action: 'create:any', attributes: '*' },
  { role: 'admin', resource: 'strands', action: 'read:any', attributes: '*' },
  { role: 'admin', resource: 'strands', action: 'update:any', attributes: '*' },
  { role: 'admin', resource: 'strands', action: 'delete:any', attributes: '*' },
  //check_lists
  { role: 'admin', resource: 'check_lists', action: 'create:any', attributes: '*' },
  { role: 'admin', resource: 'check_lists', action: 'read:any', attributes: '*' },
  { role: 'admin', resource: 'check_lists', action: 'update:any', attributes: '*' },
  { role: 'admin', resource: 'check_lists', action: 'delete:any', attributes: '*' },
  //explanation_types
  { role: 'admin', resource: 'explanation_types', action: 'create:any', attributes: '*' },
  { role: 'admin', resource: 'explanation_types', action: 'read:any', attributes: '*' },
  { role: 'admin', resource: 'explanation_types', action: 'update:any', attributes: '*' },
  { role: 'admin', resource: 'explanation_types', action: 'delete:any', attributes: '*' },
  //paper_templates
  { role: 'admin', resource: 'paper_templates', action: 'create:any', attributes: '*' },
  { role: 'admin', resource: 'paper_templates', action: 'read:any', attributes: '*' },
  { role: 'admin', resource: 'paper_templates', action: 'update:any', attributes: '*' },
  { role: 'admin', resource: 'paper_templates', action: 'delete:any', attributes: '*' },

  //dashboard
  { role: 'admin', resource: 'dashboard', action: 'create:any', attributes: '*' },
  { role: 'admin', resource: 'dashboard', action: 'read:any', attributes: '*' },
  { role: 'admin', resource: 'dashboard', action: 'update:any', attributes: '*' },
  { role: 'admin', resource: 'dashboard', action: 'delete:any', attributes: '*' },

  { role: 'admin', resource: 'users', action: 'create:any', attributes: '*' },
  { role: 'admin', resource: 'users', action: 'read:any', attributes: '*' },
  { role: 'admin', resource: 'users', action: 'update:any', attributes: '*' },
  { role: 'admin', resource: 'users', action: 'delete:any', attributes: '*' },
  // Evaluation
  { role: 'admin', resource: 'evaluations', action: 'create:any', attributes: '*' },
  { role: 'admin', resource: 'evaluations', action: 'read:any', attributes: '*' },
  { role: 'admin', resource: 'evaluations', action: 'update:any', attributes: '*' },
  { role: 'admin', resource: 'evaluations', action: 'delete:any', attributes: '*' },
  // Evaluation Request
  { role: 'admin', resource: 'evaluation_requests', action: 'create:any', attributes: '*' },
  { role: 'admin', resource: 'evaluation_requests', action: 'read:any', attributes: '*' },
  { role: 'admin', resource: 'evaluation_requests', action: 'update:any', attributes: '*' },
  { role: 'admin', resource: 'evaluation_requests', action: 'delete:any', attributes: '*' },
  // Question Cleanup
  { role: 'admin', resource: 'cleanup', action: 'create:any', attributes: '*' },
  { role: 'admin', resource: 'cleanup', action: 'read:any', attributes: '*' },
  { role: 'admin', resource: 'cleanup', action: 'update:any', attributes: '*' },

  // Question Retire
  { role: 'admin', resource: 'retired_questions', action: 'create:any', attributes: '*' },
  { role: 'admin', resource: 'retired_questions', action: 'read:any', attributes: '*' },
  { role: 'admin', resource: 'retired_questions', action: 'update:any', attributes: '*' },

  // History Logs
  { role: 'admin', resource: 'question_history', action: 'read:any', attributes: '*' },

  // Retire Roles
  { role: 'admin', resource: 'retire_rules', action: 'create:any', attributes: '*' },
  { role: 'admin', resource: 'retire_rules', action: 'read:any', attributes: '*' },
  { role: 'admin', resource: 'retire_rules', action: 'update:any', attributes: '*' },
  { role: 'admin', resource: 'retire_rules', action: 'delete:any', attributes: '*' },
  // Config
  { role: 'admin', resource: 'configurations', action: 'create:any', attributes: '*' },
  { role: 'admin', resource: 'configurations', action: 'read:any', attributes: '*' },
  { role: 'admin', resource: 'configurations', action: 'update:any', attributes: '*' },
  { role: 'admin', resource: 'configurations', action: 'delete:any', attributes: '*' },

  // national average
  { role: 'admin', resource: 'national_average', action: 'read:any', attributes: '*' },
  { role: 'admin', resource: 'national_average', action: 'create:any', attributes: '*' },

  // ai configurations
  { role: 'admin', resource: 'ai_configurations', action: 'read:any', attributes: '*' },
  { role: 'admin', resource: 'ai_configurations', action: 'create:any', attributes: '*' },
  { role: 'admin', resource: 'ai_configurations', action: 'update:any', attributes: '*' },
  { role: 'admin', resource: 'ai_configurations', action: 'delete:any', attributes: '*' },

  // project-config
  { role: 'admin', resource: 'project-setup', action: 'read:any', attributes: '*' },
  { role: 'admin', resource: 'project-setup', action: 'create:any', attributes: '*' },
  { role: 'admin', resource: 'project-setup', action: 'update:any', attributes: '*' },
  { role: 'admin', resource: 'project-setup', action: 'delete:any', attributes: '*' },

  // ___________________________ADMIN_____________________________________________________

  // ___________________________Subject In charge_____________________________________________________
  // work request
  { role: 'subjectincharge', resource: 'work_requests', action: 'create:any', attributes: '*' },
  { role: 'subjectincharge', resource: 'work_requests', action: 'read:any', attributes: '*' },
  { role: 'subjectincharge', resource: 'work_requests', action: 'update:any', attributes: '*' },
  { role: 'subjectincharge', resource: 'work_requests', action: 'delete:any', attributes: '*' },

  // paper work request
  { role: 'subjectincharge', resource: 'paper_work_requests', action: 'create:any', attributes: '*' },
  { role: 'subjectincharge', resource: 'paper_work_requests', action: 'read:any', attributes: '*' },
  { role: 'subjectincharge', resource: 'paper_work_requests', action: 'update:any', attributes: '*' },
  { role: 'subjectincharge', resource: 'paper_work_requests', action: 'delete:any', attributes: '*' },

  // questions
  { role: 'subjectincharge', resource: 'questions', action: 'read:any', attributes: '*' },

  //dashboard
  { role: 'subjectincharge', resource: 'dashboard', action: 'create:any', attributes: '*' },
  { role: 'subjectincharge', resource: 'dashboard', action: 'read:any', attributes: '*' },
  { role: 'subjectincharge', resource: 'dashboard', action: 'update:any', attributes: '*' },
  { role: 'subjectincharge', resource: 'dashboard', action: 'delete:any', attributes: '*' },

  { role: 'subjectincharge', resource: 'users', action: 'create:any', attributes: '*' },
  { role: 'subjectincharge', resource: 'users', action: 'read:any', attributes: '*' },
  { role: 'subjectincharge', resource: 'users', action: 'update:any', attributes: '*' },
  { role: 'subjectincharge', resource: 'users', action: 'delete:any', attributes: '*' },

  // --------------------Temp access---------------------------------
  { role: 'subjectincharge', resource: 'themes', action: 'create:any', attributes: '*' },
  { role: 'subjectincharge', resource: 'themes', action: 'read:any', attributes: '*' },
  { role: 'subjectincharge', resource: 'themes', action: 'update:any', attributes: '*' },

  //sub_themes
  { role: 'subjectincharge', resource: 'sub_themes', action: 'create:any', attributes: '*' },
  { role: 'subjectincharge', resource: 'sub_themes', action: 'read:any', attributes: '*' },
  { role: 'subjectincharge', resource: 'sub_themes', action: 'update:any', attributes: '*' },
  // { role: 'admin', resource: 'sub_themes', action: 'delete:any', attributes: '*' },
  //report_themes
  { role: 'subjectincharge', resource: 'report_themes', action: 'create:any', attributes: '*' },
  { role: 'subjectincharge', resource: 'report_themes', action: 'read:any', attributes: '*' },
  { role: 'subjectincharge', resource: 'report_themes', action: 'update:any', attributes: '*' },
  // { role: 'subjectincharge', resource: 'report_themes', action: 'delete:any', attributes: '*' },
  //topics
  { role: 'subjectincharge', resource: 'topics', action: 'create:any', attributes: '*' },
  { role: 'subjectincharge', resource: 'topics', action: 'read:any', attributes: '*' },
  { role: 'subjectincharge', resource: 'topics', action: 'update:any', attributes: '*' },
  // { role: 'subjectincharge', resource: 'topics', action: 'delete:any', attributes: '*' },


  // ----------------------------------------------------------------

  // ___________________________QCREATOR_____________________________________________________
  // { role: 'qcreator', resource: 'work_requests', action: 'create', attributes: '!*,' },
  { role: 'qcreator', resource: 'work_requests', action: 'read:any', attributes: '*' },
  { role: 'qcreator', resource: 'paper_work_requests', action: 'read:any', attributes: '*' },
  { role: 'qcreator', resource: 'questions', action: 'read:any', attributes: '*' },

  { role: 'qcreator', resource: 'uploaded_questions', action: 'create:any', attributes: '*' },
  { role: 'qcreator', resource: 'uploaded_questions', action: 'read:any', attributes: '*' },
  { role: 'qcreator', resource: 'uploaded_questions', action: 'update:any', attributes: '*' },
  { role: 'qcreator', resource: 'uploaded_questions', action: 'delete:any', attributes: '*' },
  
  //topics
  { role: 'qcreator', resource: 'topics', action: 'read:any', attributes: '*' },
  //sub_themes
  { role: 'qcreator', resource: 'sub_themes', action: 'read:any', attributes: '*' },
  //themes
  { role: 'qcreator', resource: 'themes', action: 'read:any', attributes: '*' },


  //dashboard
  { role: 'qcreator', resource: 'dashboard', action: 'create:any', attributes: '*' },
  { role: 'qcreator', resource: 'dashboard', action: 'read:any', attributes: '*' },
  { role: 'qcreator', resource: 'dashboard', action: 'update:any', attributes: '*' },
  { role: 'qcreator', resource: 'dashboard', action: 'delete:any', attributes: '*' },
  //   { role: 'user', resource: 'video', action: 'update:own', attributes: '*, !rating, !views' },
  //   { role: 'user', resource: 'video', action: 'delete:own', attributes: '*' }
  // ___________________________QCREATOR_____________________________________________________
  // ___________________________VCREATOR_____________________________________________________
  // { role: 'qcreator', resource: 'work_requests', action: 'create', attributes: '!*,' },
  { role: 'variantcreator', resource: 'work_requests', action: 'read:any', attributes: '*' },
  { role: 'variantcreator', resource: 'paper_work_requests', action: 'read:any', attributes: '*' },
  { role: 'variantcreator', resource: 'questions', action: 'read:any', attributes: '*' },
  //dashboard
  { role: 'variantcreator', resource: 'dashboard', action: 'create:any', attributes: '*' },
  { role: 'variantcreator', resource: 'dashboard', action: 'read:any', attributes: '*' },
  { role: 'variantcreator', resource: 'dashboard', action: 'update:any', attributes: '*' },
  { role: 'variantcreator', resource: 'dashboard', action: 'delete:any', attributes: '*' },

  // { role: 'variantcreator', resource: 'uploaded_questions', action: 'create:any', attributes: '*' },
  { role: 'variantcreator', resource: 'uploaded_questions', action: 'read:any', attributes: '*' },
  // { role: 'variantcreator', resource: 'uploaded_questions', action: 'update:any', attributes: '*' },
  // { role: 'variantcreator', resource: 'uploaded_questions', action: 'delete:any', attributes: '*' },
  //   { role: 'user', resource: 'video', action: 'update:own', attributes: '*, !rating, !views' },
  //   { role: 'user', resource: 'video', action: 'delete:own', attributes: '*' }
  // ___________________________QCREATOR_____________________________________________________
  // ___________________________QREVIEWER_____________________________________________________

  { role: 'qreviewer', resource: 'work_requests', action: 'read:any', attributes: '*' },
  { role: 'qreviewer', resource: 'paper_work_requests', action: 'read:any', attributes: '*' },
  { role: 'qreviewer', resource: 'questions', action: 'read:any', attributes: '*' },
  // { role: 'qreviewer', resource: 'draft_questions', action: 'read:any', attributes: '*' },
  //dashboard
  { role: 'qreviewer', resource: 'dashboard', action: 'create:any', attributes: '*' },
  { role: 'qreviewer', resource: 'dashboard', action: 'read:any', attributes: '*' },
  { role: 'qreviewer', resource: 'dashboard', action: 'update:any', attributes: '*' },
  { role: 'qreviewer', resource: 'dashboard', action: 'delete:any', attributes: '*' },

  //topics
  { role: 'qreviewer', resource: 'topics', action: 'read:any', attributes: '*' },
  //sub_themes
  { role: 'qreviewer', resource: 'sub_themes', action: 'read:any', attributes: '*' },
  //themes
  { role: 'qreviewer', resource: 'themes', action: 'read:any', attributes: '*' },

  //___________________________QREVIEWER_____________________________________________________

  // ___________________________QAPPROVER_____________________________________________________

  { role: 'qapprover', resource: 'work_requests', action: 'read:any', attributes: '*' },
  { role: 'qapprover', resource: 'paper_work_requests', action: 'read:any', attributes: '*' },
  { role: 'qapprover', resource: 'questions', action: 'read:any', attributes: '*' },
  // { role: 'qapprover', resource: 'draft_questions', action: 'read:any', attributes: '*' },
  //dashboard
  { role: 'qapprover', resource: 'dashboard', action: 'create:any', attributes: '*' },
  { role: 'qapprover', resource: 'dashboard', action: 'read:any', attributes: '*' },
  { role: 'qapprover', resource: 'dashboard', action: 'update:any', attributes: '*' },
  { role: 'qapprover', resource: 'dashboard', action: 'delete:any', attributes: '*' },

   //topics
   { role: 'qapprover', resource: 'topics', action: 'read:any', attributes: '*' },
   //sub_themes
   { role: 'qapprover', resource: 'sub_themes', action: 'read:any', attributes: '*' },
   //themes
   { role: 'qapprover', resource: 'themes', action: 'read:any', attributes: '*' },

  //___________________________QBINCHARGE_____________________________________________________
  // QBINCHARGE

  { role: 'qbincharge', resource: 'questions', action: 'read:any', attributes: '*' },
  { role: 'qbincharge', resource: 'questions', action: 'update:any', attributes: 'mark_retired' },

  { role: 'qbincharge', resource: 'uploaded_questions', action: 'create:any', attributes: '*' },
  { role: 'qbincharge', resource: 'uploaded_questions', action: 'read:any', attributes: '*' },
  { role: 'qbincharge', resource: 'uploaded_questions', action: 'update:any', attributes: '*' },
  { role: 'qbincharge', resource: 'uploaded_questions', action: 'delete:any', attributes: '*' },
  //dashboard
  { role: 'qbincharge', resource: 'dashboard', action: 'create:any', attributes: '*' },
  { role: 'qbincharge', resource: 'dashboard', action: 'read:any', attributes: '*' },
  { role: 'qbincharge', resource: 'dashboard', action: 'update:any', attributes: '*' },
  { role: 'qbincharge', resource: 'dashboard', action: 'delete:any', attributes: '*' },
  // Question Cleanup
  { role: 'qbincharge', resource: 'cleanup', action: 'create:any', attributes: '*' },
  { role: 'qbincharge', resource: 'cleanup', action: 'read:any', attributes: '*' },
  { role: 'qbincharge', resource: 'cleanup', action: 'update:any', attributes: '*' },
  //___________________________QBINCHARGE_____________________________________________________
  //___________________________PRODUCT MANAGER_____________________________________________________
  { role: 'productmanager', resource: 'dashboard', action: 'create:any', attributes: '*' },
  { role: 'productmanager', resource: 'dashboard', action: 'read:any', attributes: '*' },
  { role: 'productmanager', resource: 'dashboard', action: 'update:any', attributes: '*' },
  { role: 'productmanager', resource: 'dashboard', action: 'delete:any', attributes: '*' },

  { role: 'productmanager', resource: 'users', action: 'create:any', attributes: '*' },
  { role: 'productmanager', resource: 'users', action: 'read:any', attributes: '*' },
  { role: 'productmanager', resource: 'users', action: 'update:any', attributes: '*' },
  { role: 'productmanager', resource: 'users', action: 'delete:any', attributes: '*' },
  //draft_questions
  { role: 'productmanager', resource: 'draft_questions', action: 'read:any', attributes: '*' },

  //paper
  { role: 'productmanager', resource: 'papers', action: 'read:any', attributes: '*' },
  //paper_requests
  { role: 'productmanager', resource: 'paper_requests', action: 'create:any', attributes: '*' },
  { role: 'productmanager', resource: 'paper_requests', action: 'read:any', attributes: '*' },
  { role: 'productmanager', resource: 'paper_requests', action: 'update:any', attributes: '*' },
  { role: 'productmanager', resource: 'paper_requests', action: 'delete:any', attributes: '*' },
  //paper_templates
  { role: 'productmanager', resource: 'paper_templates', action: 'create:any', attributes: '*' },
  { role: 'productmanager', resource: 'paper_templates', action: 'read:any', attributes: '*' },
  { role: 'productmanager', resource: 'paper_templates', action: 'update:any', attributes: '*' },
  { role: 'productmanager', resource: 'paper_templates', action: 'delete:any', attributes: '*' },
  // Products
  { role: 'productmanager', resource: 'products', action: 'create:any', attributes: '*' },
  { role: 'productmanager', resource: 'products', action: 'read:any', attributes: '*' },
  { role: 'productmanager', resource: 'products', action: 'update:any', attributes: '*' },
  { role: 'productmanager', resource: 'products', action: 'delete:any', attributes: '*' },

  // Test Tracks
  { role: 'productmanager', resource: 'test_tracks', action: 'create:any', attributes: '*' },
  { role: 'productmanager', resource: 'test_tracks', action: 'read:any', attributes: '*' },
  { role: 'productmanager', resource: 'test_tracks', action: 'update:any', attributes: '*' },
  { role: 'productmanager', resource: 'test_tracks', action: 'delete:any', attributes: '*' },
  //Test Events
  { role: 'productmanager', resource: 'test_events', action: 'create:any', attributes: '*' },
  { role: 'productmanager', resource: 'test_events', action: 'read:any', attributes: '*' },
  { role: 'productmanager', resource: 'test_events', action: 'update:any', attributes: '*' },
  { role: 'productmanager', resource: 'test_events', action: 'delete:any', attributes: '*' },

  // work request

  { role: 'productmanager', resource: 'work_requests', action: 'read:any', attributes: '*' },
  { role: 'productmanager', resource: 'questions', action: 'read:any', attributes: '*' },
  { role: 'productmanager', resource: 'uploaded_questions', action: 'read:any', attributes: '*' },

  // paper work request

  { role: 'productmanager', resource: 'paper_work_requests', action: 'read:any', attributes: '*' },

  // questions
  { role: 'subjectincharge', resource: 'questions', action: 'read:any', attributes: '*' },

  // evaluation_request
  { role: 'productmanager', resource: 'evaluation_requests', action: 'read:any', attributes: '*' },

  // national average
  { role: 'productmanager', resource: 'national_average', action: 'read:any', attributes: '*' },
  { role: 'productmanager', resource: 'national_average', action: 'create:any', attributes: '*' },
  { role: 'productmanager', resource: 'national_average', action: 'update:any', attributes: '*' },
  { role: 'productmanager', resource: 'national_average', action: 'delete:any', attributes: '*' },

  // candidate details
  //candidates
  { role: 'productmanager', resource: 'candidates', action: 'create:any', attributes: '*' },
  { role: 'productmanager', resource: 'candidates', action: 'read:any', attributes: '*' },
  { role: 'productmanager', resource: 'candidates', action: 'update:any', attributes: '*' },
  { role: 'productmanager', resource: 'candidates', action: 'delete:any', attributes: '*' },
  { role: 'productmanager', resource: 'exam_online_ingest_jobs', action: 'read:any', attributes: '*' },
  { role: 'productmanager', resource: 'exam_online_ingest_jobs', action: 'update:any', attributes: '*' },

  //___________________________PRODUCT MANAGER_____________________________________________________

  //___________________________PAPER SETTER_____________________________________________________
  { role: 'papersetter', resource: 'dashboard', action: 'create:any', attributes: '*' },
  { role: 'papersetter', resource: 'dashboard', action: 'read:any', attributes: '*' },
  { role: 'papersetter', resource: 'dashboard', action: 'update:any', attributes: '*' },
  { role: 'papersetter', resource: 'dashboard', action: 'delete:any', attributes: '*' },
  //paper_templates
  // { role: 'papersetter', resource: 'paper_templates', action: 'create:any', attributes: '*' },
  { role: 'papersetter', resource: 'paper_templates', action: 'read:any', attributes: '*' },
  // { role: 'papersetter', resource: 'paper_templates', action: 'update:any', attributes: '*' },
  // { role: 'papersetter', resource: 'paper_templates', action: 'delete:any', attributes: '*' },

  //paper
  { role: 'papersetter', resource: 'papers', action: 'create:any', attributes: '*' },
  { role: 'papersetter', resource: 'papers', action: 'read:any', attributes: '*' },
  { role: 'papersetter', resource: 'papers', action: 'update:any', attributes: '*' },
  { role: 'papersetter', resource: 'papers', action: 'delete:any', attributes: '*' },

  //paper requests
  // { role: 'papersetter', resource: 'paper_requests', action: 'create:any', attributes: '*' },
  { role: 'papersetter', resource: 'paper_requests', action: 'read:any', attributes: '*' },
  // { role: 'papersetter', resource: 'paper_requests', action: 'update:any', attributes: '*' },
  // { role: 'papersetter', resource: 'paper_requests', action: 'delete:any', attributes: '*' },

  // Test Tracks
  // { role: 'papersetter', resource: 'test_tracks', action: 'create:any', attributes: '*' },
  { role: 'papersetter', resource: 'test_tracks', action: 'read:any', attributes: '*' },
  // { role: 'papersetter', resource: 'test_tracks', action: 'update:any', attributes: '*' },
  // { role: 'papersetter', resource: 'test_tracks', action: 'delete:any', attributes: '*' },
  //work requests
  { role: 'papersetter', resource: 'work_requests', action: 'create:any', attrubutes: '*' },
  { role: 'papersetter', resource: 'work_requests', action: 'read:any', attrubutes: '*' },
  { role: 'papersetter', resource: 'work_requests', action: 'update:any', attrubutes: '*' },
  { role: 'papersetter', resource: 'work_requests', action: 'delete:any', attrubutes: '*' },

  { role: 'papersetter', resource: 'draft_questions', action: 'read:any', attrubutes: '*' },

  //___________________________PAPER APPROVER_____________________________________________________

  { role: 'paperapprover', resource: 'dashboard', action: 'create:any', attributes: '*' },
  { role: 'paperapprover', resource: 'dashboard', action: 'read:any', attributes: '*' },
  { role: 'paperapprover', resource: 'dashboard', action: 'update:any', attributes: '*' },
  { role: 'paperapprover', resource: 'dashboard', action: 'delete:any', attributes: '*' },

  //paper
  { role: 'paperapprover', resource: 'papers', action: 'create:any', attributes: '*' },
  { role: 'paperapprover', resource: 'papers', action: 'read:any', attributes: '*' },
  { role: 'paperapprover', resource: 'papers', action: 'update:any', attributes: '*' },
  { role: 'paperapprover', resource: 'papers', action: 'delete:any', attributes: '*' },

  //paper requests
  { role: 'paperapprover', resource: 'paper_requests', action: 'create:any', attributes: '*' },
  { role: 'paperapprover', resource: 'paper_requests', action: 'read:any', attributes: '*' },
  { role: 'paperapprover', resource: 'paper_requests', action: 'update:any', attributes: '*' },
  { role: 'paperapprover', resource: 'paper_requests', action: 'delete:any', attributes: '*' },

  //test_tracks and templates
  { role: 'paperapprover', resource: 'test_tracks', action: 'read:any', attributes: '*' },
  { role: 'paperapprover', resource: 'paper_templates', action: 'read:any', attributes: '*' },

  //draft_questions
  { role: 'paperapprover', resource: 'draft_questions', action: 'read:any', attrubutes: '*' },
  //questions
  { role: 'paperapprover', resource: 'questions', action: 'read:any', attribute: '*' },

  //___________________________PRODUCT MANAGER_____________________________________________________

  //dashboard
  { role: 'user', resource: 'dashboard', action: 'create:any', attributes: '*' },
  { role: 'user', resource: 'dashboard', action: 'read:any', attributes: '*' },
  { role: 'user', resource: 'dashboard', action: 'update:any', attributes: '*' },
  { role: 'user', resource: 'dashboard', action: 'delete:any', attributes: '*' },
  //dashboard
  { role: 'me', resource: 'dashboard', action: 'create:any', attributes: '*' },
  { role: 'me', resource: 'dashboard', action: 'read:any', attributes: '*' },
  { role: 'me', resource: 'dashboard', action: 'update:any', attributes: '*' },
  { role: 'me', resource: 'dashboard', action: 'delete:any', attributes: '*' },

  //___________________________EVALUATION_____________________________________________________
  // Delivery Manager
  //  { role: 'deliverymanager', resource: 'dashboard', action: 'create:any', attributes: '*' },
  // { role: 'deliverymanager', resource: 'dashboard', action: 'read:any', attributes: '*' },
  // { role: 'deliverymanager', resource: 'dashboard', action: 'update:any', attributes: '*' },
  // { role: 'deliverymanager', resource: 'dashboard', action: 'delete:any', attributes: '*' },
  //test_events
  { role: 'deliverymanager', resource: 'test_events', action: 'create:any', attributes: '*' },
  { role: 'deliverymanager', resource: 'test_events', action: 'read:any', attributes: '*' },
  { role: 'deliverymanager', resource: 'test_events', action: 'update:any', attributes: '*' },
  { role: 'deliverymanager', resource: 'test_events', action: 'delete:any', attributes: '*' },
  { role: 'deliverymanager', resource: 'dashboard', action: 'create:any', attributes: '*' },
  { role: 'deliverymanager', resource: 'dashboard', action: 'read:any', attributes: '*' },
  { role: 'deliverymanager', resource: 'dashboard', action: 'update:any', attributes: '*' },
  { role: 'deliverymanager', resource: 'dashboard', action: 'delete:any', attributes: '*' },

  { role: 'deliverymanager', resource: 'evaluation_requests', action: 'create:any', attributes: '*' },
  // { role: 'deliverymanager', resource: 'evaluation_requests', action: 'read:any', attributes: '*' },
  { role: 'deliverymanager', resource: 'evaluation_requests', action: 'update:any', attributes: '*' },
  { role: 'deliverymanager', resource: 'evaluation_requests', action: 'delete:any', attributes: '*' },

  { role: 'deliverymanager', resource: 'report_generation', action: 'create:any', attributes: '*' },
  { role: 'deliverymanager', resource: 'report_generation', action: 'read:any', attributes: '*' },
  { role: 'deliverymanager', resource: 'report_generation', action: 'update:any', attributes: '*' },
  { role: 'deliverymanager', resource: 'report_generation', action: 'delete:any', attributes: '*' },

  //candidates
  { role: 'deliverymanager', resource: 'candidates', action: 'create:any', attributes: '*' },
  { role: 'deliverymanager', resource: 'candidates', action: 'read:any', attributes: '*' },
  { role: 'deliverymanager', resource: 'exam_online_ingest_jobs', action: 'read:any', attributes: '*' },
  // { role: 'deliverymanager', resource: 'evaluations', action: 'create:any', attributes: '*' },
  { role: 'deliverymanager', resource: 'evaluations', action: 'read:any', attributes: '*' },
  // { role: 'deliverymanager', resource: 'evaluations', action: 'update:any', attributes: '*' },
  // { role: 'deliverymanager', resource: 'evaluations', action: 'delete:any', attributes: '*' },
  // ----------------------------------------------------------------------------------------------
  // Evaluation In Charge
  { role: 'evaluationincharge', resource: 'dashboard', action: 'create:any', attributes: '*' },
  { role: 'evaluationincharge', resource: 'dashboard', action: 'read:any', attributes: '*' },
  { role: 'evaluationincharge', resource: 'dashboard', action: 'update:any', attributes: '*' },
  { role: 'evaluationincharge', resource: 'dashboard', action: 'delete:any', attributes: '*' },
  //test_events
  // { role: 'evaluationincharge', resource: 'test_events', action: 'create:any', attributes: '*' },
  // { role: 'evaluationincharge', resource: 'test_events', action: 'read:any', attributes: '*' },
  // { role: 'evaluationincharge', resource: 'test_events', action: 'update:any', attributes: '*' },
  // { role: 'evaluationincharge', resource: 'test_events', action: 'delete:any', attributes: '*' },

  //  { role: 'evaluationincharge', resource: 'evaluation_requests', action: 'create:any', attributes: '*' },
  { role: 'evaluationincharge', resource: 'evaluation_requests', action: 'read:any', attributes: '*' },
  // { role: 'evaluationincharge', resource: 'evaluation_requests', action: 'update:any', attributes: '*' },
  // { role: 'evaluationincharge', resource: 'evaluation_requests', action: 'delete:any', attributes: '*' },

  //   { role: 'evaluationincharge', resource: 'report_generation', action: 'create:any', attributes: '*' },
  // { role: 'evaluationincharge', resource: 'report_generation', action: 'read:any', attributes: '*' },
  // { role: 'evaluationincharge', resource: 'report_generation', action: 'update:any', attributes: '*' },
  // { role: 'evaluationincharge', resource: 'report_generation', action: 'delete:any', attributes: '*' },

  { role: 'evaluationincharge', resource: 'evaluations', action: 'create:any', attributes: '*' },
  { role: 'evaluationincharge', resource: 'evaluations', action: 'read:any', attributes: '*' },
  // { role: 'evaluationincharge', resource: 'evaluations', action: 'update:any', attributes: '*' },
  // { role: 'evaluationincharge', resource: 'evaluations', action: 'delete:any', attributes: '*' },

  // ----------------------------------------------------------------------------------------------
  //  Evaluators
  { role: 'evaluators', resource: 'dashboard', action: 'create:any', attributes: '*' },
  { role: 'evaluators', resource: 'dashboard', action: 'read:any', attributes: '*' },
  { role: 'evaluators', resource: 'dashboard', action: 'update:any', attributes: '*' },
  { role: 'evaluators', resource: 'dashboard', action: 'delete:any', attributes: '*' },
  //test_events
  // { role: 'evaluators', resource: 'test_events', action: 'create:any', attributes: '*' },
  // { role: 'evaluators', resource: 'test_events', action: 'read:any', attributes: '*' },
  // { role: 'evaluators', resource: 'test_events', action: 'update:any', attributes: '*' },
  // { role: 'evaluators', resource: 'test_events', action: 'delete:any', attributes: '*' },

  //  { role: 'evaluators', resource: 'evaluations', action: 'create:any', attributes: '*' },
  { role: 'evaluators', resource: 'evaluations', action: 'read:any', attributes: '*' },
  // { role: 'evaluators', resource: 'evaluations', action: 'update:any', attributes: '*' },
  // { role: 'evaluators', resource: 'evaluations', action: 'delete:any', attributes: '*' },
  // { role: 'evaluators', resource: 'evaluation_requests', action: 'read:any', attributes: '*' },
  { role: 'evaluators', resource: 'file_upload', action: 'create:any', attributes: '*' },

  //___________________________EVALUATION_____________________________________________________
  //___________________________SR MANAGER_____________________________________________________

  { role: 'srmanager', resource: 'dashboard', action: 'create:any', attributes: '*' },
  { role: 'srmanager', resource: 'dashboard', action: 'read:any', attributes: '*' },
  { role: 'srmanager', resource: 'dashboard', action: 'update:any', attributes: '*' },
  { role: 'srmanager', resource: 'dashboard', action: 'delete:any', attributes: '*' },
  { role: 'srmanager', resource: 'users', action: 'create:any', attributes: '*' },
  { role: 'srmanager', resource: 'users', action: 'read:any', attributes: '*' },
  { role: 'srmanager', resource: 'users', action: 'update:any', attributes: '*' },
  { role: 'srmanager', resource: 'users', action: 'delete:any', attributes: '*' },
  // work request
  { role: 'srmanager', resource: 'work_requests', action: 'create:any', attributes: '*' },
  { role: 'srmanager', resource: 'work_requests', action: 'read:any', attributes: '*' },
  { role: 'srmanager', resource: 'work_requests', action: 'update:any', attributes: '*' },
  { role: 'srmanager', resource: 'work_requests', action: 'delete:any', attributes: '*' },

  // paper work request
  { role: 'srmanager', resource: 'paper_work_requests', action: 'create:any', attributes: '*' },
  { role: 'srmanager', resource: 'paper_work_requests', action: 'read:any', attributes: '*' },
  { role: 'srmanager', resource: 'paper_work_requests', action: 'update:any', attributes: '*' },
  { role: 'srmanager', resource: 'paper_work_requests', action: 'delete:any', attributes: '*' },

  // questions
  { role: 'srmanager', resource: 'questions', action: 'create:any', attributes: '*' },
  { role: 'srmanager', resource: 'questions', action: 'read:any', attributes: '*' },
  { role: 'srmanager', resource: 'questions', action: 'update:any', attributes: '*' },
  { role: 'srmanager', resource: 'questions', action: 'delete:any', attributes: '*' },
  //report
  { role: 'srmanager', resource: 'report', action: 'create:any', attributes: '*' },
  { role: 'srmanager', resource: 'report', action: 'read:any', attributes: '*' },
  { role: 'srmanager', resource: 'report', action: 'update:any', attributes: '*' },
  { role: 'srmanager', resource: 'report', action: 'delete:any', attributes: '*' },

  // History Logs
  { role: 'srmanager', resource: 'question_history', action: 'read:any', attributes: '*' },

  // --------------------Temp access---------------------------------
  { role: 'srmanager', resource: 'themes', action: 'create:any', attributes: '*' },
  { role: 'srmanager', resource: 'themes', action: 'read:any', attributes: '*' },
  { role: 'srmanager', resource: 'themes', action: 'update:any', attributes: '*' },

  //sub_themes
  { role: 'srmanager', resource: 'sub_themes', action: 'create:any', attributes: '*' },
  { role: 'srmanager', resource: 'sub_themes', action: 'read:any', attributes: '*' },
  { role: 'srmanager', resource: 'sub_themes', action: 'update:any', attributes: '*' },
  // { role: 'admin', resource: 'sub_themes', action: 'delete:any', attributes: '*' },
  //report_themes
  { role: 'srmanager', resource: 'report_themes', action: 'create:any', attributes: '*' },
  { role: 'srmanager', resource: 'report_themes', action: 'read:any', attributes: '*' },
  { role: 'srmanager', resource: 'report_themes', action: 'update:any', attributes: '*' },
  // { role: 'subjectincharge', resource: 'report_themes', action: 'delete:any', attributes: '*' },
  //topics
  { role: 'srmanager', resource: 'topics', action: 'create:any', attributes: '*' },
  { role: 'srmanager', resource: 'topics', action: 'read:any', attributes: '*' },
  { role: 'srmanager', resource: 'topics', action: 'update:any', attributes: '*' },
  // { role: 'subjectincharge', resource: 'topics', action: 'delete:any', attributes: '*' },
  // support_tasks
  { role: 'srmanager', resource: 'support_tasks', action: 'read:any', attributes: '*' },

  // Question Retire
  { role: 'srmanager', resource: 'retire_rules', action: 'create:any', attributes: '*' },
  { role: 'srmanager', resource: 'retire_rules', action: 'read:any', attributes: '*' },
  { role: 'srmanager', resource: 'retire_rules', action: 'update:any', attributes: '*' },

  // ----------------------------------------------------------------

  //___________________________SR MANAGER_____________________________________________________

  //___________________________SYSTEM SUPPORT_____________________________________________________
  // dashboard
  { role: 'systemsupport', resource: 'dashboard', action: 'read:any', attributes: '*' },
  // support_tasks
  { role: 'systemsupport', resource: 'tasks', action: 'read:any', attributes: '*' },
  { role: 'systemsupport', resource: 'tasks', action: 'update:any', attributes: '*' },
  //___________________________SYSTEM SUPPORT_____________________________________________________
]

const ac = new AccessControl(grantList)
ac.grant('superuser').extend('admin')
// ac.grant('productmanager').extend('admin')
ac.setGrants(grantList)
export default ac
